import { MagicConfigMixin, interpolate, FeatureEnabledV2 } from '@gig/magic-common';
import { Mixins, Component } from 'vue-property-decorator';
import { Feature } from '@gig/magic-messages';
import { NotificationDelay } from '../../services/notifications/notifications.constants.js';
import '../../services/notifications/notification.js';
import { notificationService } from '../../services/notifications/notifications.service.js';
import '../../services/live-chat/live-chat.service.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let NotificationsComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.notifications = notificationService.notifications;
    this.isToastNotification = false;
    this.isTopNavEnabled = false;
  }
  close(notification) {
    notificationService.close(notification);
  }
  interpolate(text) {
    if (typeof text === "string") {
      return interpolate(text, this.magicConfig.interpolationParams, true);
    }
    return text;
  }
  progressVariant(closeDelay) {
    switch (closeDelay) {
      case NotificationDelay.DEFAULT:
        return "default";
      case NotificationDelay.SHORT:
        return "short";
      case NotificationDelay.LONG:
        return "long";
      case NotificationDelay.PERMANENT:
        return "permanent";
    }
  }
};
__decorateClass([
  FeatureEnabledV2({
    slug: Feature.TIMED_TOAST_NOTIFICATIONS
  })
], NotificationsComponent.prototype, "isToastNotification", 2);
__decorateClass([
  FeatureEnabledV2({
    slug: Feature.TOP_NAVIGATION
  })
], NotificationsComponent.prototype, "isTopNavEnabled", 2);
NotificationsComponent = __decorateClass([
  Component({
    name: "notifications"
  })
], NotificationsComponent);

export default NotificationsComponent;
